
import Layout from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import { Contact } from "lucide-react";

const ContactSupport = () => (
  <Layout>
    <div className="max-w-2xl mx-auto px-4 py-12">
      <div className="flex items-center mb-6">
        <Contact className="h-8 w-8 text-ai-indigo mr-3" />
        <h1 className="text-3xl font-bold">Contact Support</h1>
      </div>
      <p className="mb-4 text-gray-700">
        We're here to help! For questions, feedback, or technical issues, please reach out to our support team using the methods below.
      </p>
      <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Email</h2>
        <p>
          Send us an email at{" "}
          <a 
            href="mailto:support@ai-nexus.com" 
            className="text-ai-indigo underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            support@ai-nexus.com
          </a>
          .
        </p>
      </div>
      <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Frequently Asked Questions</h2>
        <p>
          You might find a quick answer in our <a href="/pricing#faq" className="underline text-ai-indigo">FAQ section</a> on the Pricing page.
        </p>
      </div>
      <div>
        <h2 className="text-xl font-semibold mb-2">Other inquiries</h2>
        <p>
          For business or partnership inquiries, use the email above and our team will get back to you as soon as possible.
        </p>
      </div>
      <div className="mt-8">
        <Button asChild>
          <a href="mailto:support@ai-nexus.com">Email Support</a>
        </Button>
      </div>
    </div>
  </Layout>
);

export default ContactSupport;
